<template>
  <div class="auth-page login-page">
    <!-- Logo positioned at top -->
    <div class="logo-container">
      <img src="../assets/images/makeping-logo1.svg" alt="MakePing" class="logo" />
    </div>

    <!-- Main Content Centered -->
    <div class="content-wrapper">
      <!-- Title -->
      <h1 class="page-title">
        You're just <span class="text-orange">One Step</span> away.
      </h1>
      
      <!-- Form Card -->
      <div class="auth-card">
        <form @submit.prevent="Login()">
          <!-- Email -->
          <div class="form-group">
            <label for="email" class="form-label">Your Email</label>
            <div class="input-wrapper">
              <img src="../assets/images/icons/mail-icon.svg" class="input-icon" alt="email" />
              <input
                v-model="input.email"
                type="email"
                id="email"
                class="form-control custom-input"
                placeholder="Enter your email"
                maxlength="50"
                autocomplete="email"
                required
              />
            </div>
          </div>

          <!-- Password -->
          <div class="form-group">
            <label for="password" class="form-label">
              your Password
            </label>
            <div class="input-wrapper">
              <img src="../assets/images/icons/lock-icon.svg" class="input-icon" alt="lock" />
              <input
                v-model="input.password"
                :type="showPassword ? 'text' : 'password'"
                id="password"
                class="form-control custom-input"
                :placeholder="input.password ? '••••••••' : 'Enter Password'"
                maxlength="30"
                autocomplete="current-password"
                required
              />
              <img 
                v-if="showPassword && input.password"
                src="../assets/fonts/feather/eye.svg"
                class="toggle-password"
                @click="togglePassword('password')"
                title="hide password"
                alt="hide password"
              />
              <img 
                v-else-if="!showPassword && input.password"
                src="../assets/images/icons/eye-closed.svg"
                class="toggle-password"
                @click="togglePassword('password')"
                title="show password"
                alt="show password"
              />
            </div>
          </div>

          <!-- Forgot Password Link -->
          <div class="forgot-password-link">
            <router-link to="/auth/forgetpassword" class="text-primary">
              Forgot Password
            </router-link>
          </div>

          <!-- Login Button -->
          <button type="submit" class="btn btn-auth-primary" :disabled="loading">
            <span v-if="loading" class="spinner-border spinner-border-sm mr-2"></span>
            Login now
          </button>

          <!-- Google Sign In -->
          <button type="button" class="btn btn-google" @click="OngoogleLogin()" :disabled="loading">
            <img src="../assets/images/google_logo.webp" alt="Google" class="google-icon" />
            Sign up with Google
          </button>

          <!-- Divider -->
          <hr class="form-divider" />

          <!-- Create account link -->
          <div class="register-link-container">
            <router-link to="/auth/register" class="auth-link">
              Create your free account - Register now!
            </router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import UserController from "../../services/userController"
import Userauth from "../auth/js/index";
import Config from "../../services/config"
    export default {
        name: 'login',
        data(){
          return{
            showPassword:false,
            verify_password:'',
            input:{email:'',password:'',source:'',clickid:''},
            auth:'',
            loading:false,
            googleLogin:'',
            userPlanNotExist: false
          }
        },
        async mounted(){
          if(this.$route.query.action){
            await this.loginCheck()
          }
            if(Userauth.isAuthenticated() && Userauth.checAlive()){
                let user  = JSON.parse(window.localStorage.getItem('userinfo'))
                if(user.role == 'manager'){
                    this.$router.replace("/manager/users");
                }
                else if(user.role == 'moderator'){
                    this.$router.replace("/moderator/userInfo");
                }
                else{
                    this.$router.replace("/app/dashboard");
                }
                this.$toasted.show('Successfully Logged In to - '+user.email, {theme: 'outline',position: "bottom-center", type: 'success', duration: 2000});
            }
            if(this.$root.$data.clickid){this.input.clickid = this.$root.$data.clickid}
            if(this.$root.$data.source){this.input.source = this.$root.$data.source}
            
            this.googleLogin = Config.googleLogin+'?source='+this.input.source+'&clickid='+this.input.clickid
        },
        methods: {
          OngoogleLogin(){
            if(!this.loading){
              this.loading = true;
              window.location.href = this.googleLogin
            }
          },
        async loginCheck(){
          let response = await UserController.acceptCall(this.input)
          if(response.result){
            this.checkPlan()
            if(!this.userPlanNotExist) {
              if(response.message.isactive){
                Userauth.localLogin(response.message);
                this.$router.replace("/app/dashboard");
              } else {
                // Store userid and role in localStorage
                localStorage.setItem('inactiveUserData', JSON.stringify({
                  userid: response.message.userid,
                  role: response.message.role
                }));
                
                this.$router.replace({ 
                  path: "/inactiveUser"
                });
              }
            
            } else {
              this.$router.replace({ path: "/auth/verification", query: { from: "login" } });
            }
          }
        },
        async checkPlan() {
          let response = await UserController.getPlanInfo();
          if (response.result) {
            let plan = response.message 
            let plan_type = plan.plan_type
            let expiry_date = new Date(plan.expiry_date)
            let today = new Date()
            if (plan_type == 1 || today >= expiry_date || plan == "PLAN_NOT_FOUND") {
              this.userPlanNotExist = true
            } else {
              this.userPlanNotExist = false
            }
          }
        },
        async Login(){
            if(this.validate()){
                // this.$router.replace("/");
                this.loading = true
                let response = await UserController.login(this.input)
                console.log("response", response)

                if (response.result && response.message) {
                  const { role, isactive } = response.message;

                  if (role == 'manager') {
                      Userauth.localLogin(response.message);
                      this.$toasted.show('Successfully Logged In', { theme: 'outline', position: "bottom-center", type: 'success', duration: 2000 });
                      this.$router.replace("/manager/users");

                      this.auth = setInterval(() => {
                          this.Auth();
                      }, 120000);

                  } else if (role == 'moderator') {
                      if(!isactive) {
                        // Store userid and role in localStorage
                        localStorage.setItem('inactiveUserData', JSON.stringify({
                          userid: response.message.userid,
                          role: response.message.role
                        }));
                        
                        this.$router.replace({ 
                          path: "/inactiveUser"
                        });
                      } else {
                        Userauth.localLogin(response.message);
                        this.$toasted.show('Successfully Logged In', { theme: 'outline', position: "bottom-center", type: 'success', duration: 2000 });
                        this.$router.replace("/moderator/userInfo");

                          this.auth = setInterval(() => {
                              this.Auth();
                          }, 120000);
                      }
                  } else if (role == 'user' || role == 'subUser') {
                    await this.checkPlan()
                    if (this.userPlanNotExist) {
                        this.$router.replace({ path: "/auth/verification", query: { from: "login" } });
                    } else if (!isactive) {
                        // Store userid and role in localStorage
                        localStorage.setItem('inactiveUserData', JSON.stringify({
                          userid: response.message.userid,
                          role: response.message.role
                        }));
                        
                        this.$router.replace({ 
                          path: "/inactiveUser"
                        });
                    } else {
                        Userauth.localLogin(response.message);
                        this.$toasted.show('Successfully Logged In', { theme: 'outline', position: "bottom-center", type: 'success', duration: 2000 });
                        this.$router.replace("/app/dashboard");

                        this.auth = setInterval(() => {
                            this.Auth();
                        }, 120000);
                    }
                  } 
                } else {
                this.$toasted.show(response.message, { theme: 'outline', position: "bottom-center", type: 'error', duration: 2000 });
                }
              }
                this.loading = false
          },
          async Auth() {
          let  response = await UserController.authenticate()
          if(response != true){
            clearInterval(this.auth)
            Userauth.Logout();
          }
        },
        validateEmail(email) {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return regex.test(email);
          },

        validate(){
          if(this.validateEmail(this.input.email)){
              if(this.input.email =='' && this.input.password == ''){
                  this.$toasted.show("Please enter a valid email address and password", {theme: 'outline',position: "bottom-center", type: 'error', duration: 2000});
                return false;
            }
            return true;
            }
          else{
            this.$toasted.show("Invalid Email", {theme: 'outline',position: "bottom-center", type: 'error', duration: 2000});
            return false;
          }
        },
        togglePassword(id){
          const password = document.getElementById(id);
          this.showPassword = this.showPassword === false ? true: false
          const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
          password.setAttribute('type', type);
        }
        }
    }
</script>

<style>
@import '../assets/css/auth.css';
</style>

<style scoped>
/* Login page specific styles */
.register-link-container {
  text-align: center;
  margin-top: 0;
}
</style>